import React from 'react';
import { Shield, Lock, ShieldAlert } from 'lucide-react';

export default function SecurityRadar() {
    return (
        <div className="relative w-[300px] h-[300px] mx-auto flex items-center justify-center">

            {/* 1. Concentric Ripples (Static & Pulse) */}
            <div className="absolute inset-0 rounded-full border border-[var(--color-md-primary)]/10 animate-[ping_3s_cubic-bezier(0,0,0.2,1)_infinite]" />
            <div className="absolute inset-[15%] rounded-full border border-[var(--color-md-primary)]/20" />
            <div className="absolute inset-[30%] rounded-full border border-[var(--color-md-primary)]/30" />

            {/* 2. Orbit Track (Dashed) */}
            <div className="absolute inset-[10%] rounded-full border border-dashed border-[var(--color-md-primary)]/30 animate-[spin_10s_linear_infinite]" />

            {/* 3. Orbiting Dot */}
            <div className="absolute inset-[10%] animate-[spin_10s_linear_infinite]">
                <div className="absolute top-[-4px] left-1/2 -translate-x-1/2 w-2.5 h-2.5 bg-[var(--color-md-primary)] rounded-full glow-md" />
            </div>

            {/* 4. Central Core: Dark Shield */}
            <div className="relative z-10 w-20 h-20 bg-[var(--color-md-on-primary-container)] rounded-full flex items-center justify-center shadow-2xl ring-4 ring-[var(--color-md-primary)]/20">
                <Shield className="text-[var(--color-md-primary)] w-8 h-8" strokeWidth={2} />
            </div>
            <div className="absolute z-0 w-20 h-20 bg-[var(--color-md-primary)]/20 rounded-full blur-xl animate-pulse" />

            {/* 5. Floating Badge: Breach Blocked (Top Left) */}
            <div className="absolute top-[10%] left-[-10%] bg-rose-50 border border-rose-100 shadow-lg px-3 py-1.5 rounded-full flex items-center gap-2 animate-[float_6s_ease-in-out_infinite_0s]">
                <div className="p-1 bg-rose-100 rounded-full">
                    <ShieldAlert className="w-3 h-3 text-rose-600" />
                </div>
                <span className="text-[10px] font-bold text-rose-700 tracking-wider uppercase">Breach Blocked</span>
            </div>

            {/* 6. Floating Badge: Local Only (Bottom Right) */}
            <div className="absolute bottom-[15%] right-[-10%] bg-[var(--color-md-primary-container)] border border-[var(--color-md-primary)]/20 shadow-lg px-3 py-1.5 rounded-full flex items-center gap-2 animate-[float_5s_ease-in-out_infinite_1s]">
                <div className="p-1 bg-[var(--color-md-primary)]/20 rounded-full">
                    <Lock className="w-3 h-3 text-[var(--color-md-on-primary-container)]" />
                </div>
                <span className="text-[10px] font-bold text-[var(--color-md-on-primary-container)] tracking-wider uppercase">Local Only</span>
            </div>

        </div>
    );
}
